import { Search, Filter, MoreHorizontal } from 'lucide-react'

const leads = [
  { name: 'Maria Silva', phone: '(98) 99999-1234', cause: 'Trabalhista', urgency: 'Alta', status: 'Qualificado', date: '07/10/2026' },
  { name: 'João Santos', phone: '(98) 99999-5678', cause: 'Família', urgency: 'Média', status: 'Em conversa', date: '07/10/2026' },
  { name: 'Ana Oliveira', phone: '(98) 99999-9012', cause: 'Contrato', urgency: 'Baixa', status: 'Agendado', date: '06/10/2026' },
  { name: 'Carlos Lima', phone: '(98) 99999-3456', cause: 'Imobiliário', urgency: 'Alta', status: 'Novo', date: '06/10/2026' },
  { name: 'Fernanda Costa', phone: '(98) 99999-7890', cause: 'Trabalhista', urgency: 'Média', status: 'Qualificado', date: '05/10/2026' },
]

const statusColors: Record<string, string> = {
  'Novo': 'bg-muted text-muted-foreground',
  'Em conversa': 'bg-accent/10 text-accent',
  'Qualificado': 'bg-primary/10 text-primary',
  'Agendado': 'bg-secondary/10 text-secondary',
}

export default function LeadsPage() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="font-serif text-2xl font-semibold text-foreground">Leads</h1>
          <p className="mt-1 text-sm text-muted-foreground">Gerencie os leads qualificados pelo bot</p>
        </div>
        <div className="flex gap-2">
          <div className="relative flex-1 sm:w-64">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
            <input
              type="text"
              placeholder="Buscar lead..."
              className="flex h-10 w-full rounded-md border border-border bg-background pl-9 pr-3 text-sm text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 touch-target"
            />
          </div>
          <button className="flex h-10 items-center gap-2 rounded-md border border-border bg-card px-3 text-sm font-medium text-foreground hover:bg-muted transition-colors touch-target">
            <Filter className="h-4 w-4" />
            <span className="hidden sm:inline">Filtrar</span>
          </button>
        </div>
      </div>

      {/* Mobile: Card List */}
      <div className="space-y-3 lg:hidden">
        {leads.map((lead) => (
          <div key={lead.phone} className="rounded-lg border border-border bg-card p-4 space-y-3">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm font-medium text-foreground">{lead.name}</p>
                <p className="text-xs text-muted-foreground">{lead.phone}</p>
              </div>
              <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${statusColors[lead.status] || statusColors['Novo']}`}>
                {lead.status}
              </span>
            </div>
            <div className="flex items-center justify-between text-xs text-muted-foreground">
              <span>{lead.cause}</span>
              <span>Urgência: {lead.urgency}</span>
            </div>
            <div className="flex items-center justify-between pt-2 border-t border-border">
              <span className="text-xs text-muted-foreground">{lead.date}</span>
              <button className="rounded p-1 text-muted-foreground hover:text-foreground touch-target">
                <MoreHorizontal className="h-5 w-5" />
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Desktop: Table */}
      <div className="hidden lg:block rounded-lg border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-5 py-3 text-left font-medium text-muted-foreground">Nome</th>
              <th className="px-5 py-3 text-left font-medium text-muted-foreground">Telefone</th>
              <th className="px-5 py-3 text-left font-medium text-muted-foreground">Causa</th>
              <th className="px-5 py-3 text-left font-medium text-muted-foreground">Urgência</th>
              <th className="px-5 py-3 text-left font-medium text-muted-foreground">Status</th>
              <th className="px-5 py-3 text-left font-medium text-muted-foreground">Data</th>
              <th className="px-5 py-3 text-right font-medium text-muted-foreground"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {leads.map((lead) => (
              <tr key={lead.phone} className="hover:bg-muted/30 transition-colors">
                <td className="px-5 py-4 font-medium text-foreground">{lead.name}</td>
                <td className="px-5 py-4 text-muted-foreground">{lead.phone}</td>
                <td className="px-5 py-4 text-muted-foreground">{lead.cause}</td>
                <td className="px-5 py-4 text-muted-foreground">{lead.urgency}</td>
                <td className="px-5 py-4">
                  <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${statusColors[lead.status] || statusColors['Novo']}`}>
                    {lead.status}
                  </span>
                </td>
                <td className="px-5 py-4 text-muted-foreground">{lead.date}</td>
                <td className="px-5 py-4 text-right">
                  <button className="rounded p-1 text-muted-foreground hover:text-foreground touch-target">
                    <MoreHorizontal className="h-5 w-5" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}